import PharmacyActiveModal from './PharmacyActiveModal';

export default PharmacyActiveModal;
